import React from "react";
import PropTypes from "prop-types";
import SummaryItem from "../components/SummaryItem.jsx";
import SectionItem from "../components/SectionItem.jsx";
import AudioFile from "../components/AudioFile.jsx";

const PreConnectionGreeting = (props) => (
  <SummaryItem itemKey={"Pre-Connection Greeting: "}>
    <SectionItem itemKey={"Audio"}>
      <AudioFile audioId={props.module.audio} />
    </SectionItem>
  </SummaryItem>
);

export default PreConnectionGreeting;

PreConnectionGreeting.propTypes = {
  module: PropTypes.object,
  sites: PropTypes.array,
  clientId: PropTypes.any,
};
